import axios from 'axios'
import Auth from '@/services/auth'
import {
  API_BASE,
  apiErrorHandler,
  ApiFilter,
  isDefinedAndNotNull,
  isNotEmpty,
} from '@/services/api'

const NOMINATIONS_ENDPOINT = `${API_BASE}nominations/`

const NominationsApi = {
  getRequestOptions() {
    return {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
    }
  },

  // Helper to retrieve all nominations for the current user (NOMINATED status only for admins) from the Nominations API service
  async list() {
    try {
      const response = await axios.get(NOMINATIONS_ENDPOINT + 'list', this.getRequestOptions())

      return response.data
    } catch (error) {
      console.error(error)
    }

    return null
  },

  // Helper to retrieve a single nomination by ID from the Nominations API service
  async get(id) {
    try {
      const response = await axios.post(
        NOMINATIONS_ENDPOINT + 'get',
        {nomination_id: id},
        this.getRequestOptions(),
      )

      return response.data
    } catch (error) {
      console.error(error)
    }

    return null
  },

  // Helper to retrieve a nominee's enrolled date from the Nominations API service
  async getEnrolledDate(id) {
    try {
      const response = await axios.get(
        NOMINATIONS_ENDPOINT + 'enrolled-date',
        {
          ...this.getRequestOptions(),
          params: {nominee_id: id},
        }
      )

      return response.data
    } catch (error) {
      console.error(error)
    }

    return null
  },

  async getAtRisk(id) {
    try {
      const response = await axios.get(
        NOMINATIONS_ENDPOINT + 'at-risk',
        {
          ...this.getRequestOptions(),
          params: {nominee_id: id},
        }
      )

      return response.data
    } catch (error) {
      console.error(error)
    }

    return null
  },

  // Helper to create a new nomination for the current user from the Nominations API service
  async create() {
    try {
      const response = await axios.get(NOMINATIONS_ENDPOINT + 'create', this.getRequestOptions())

      return response.data
    } catch (error) {
      console.error(error)
    }

    return null
  },

  async updateStatus(id, status, message = '') {
    try {
      const response = await axios.post(
        NOMINATIONS_ENDPOINT + 'update-status',
        {
          nomination_id: id,
          status: status,
          message: message,
        },
        this.getRequestOptions(),
      )

      return
    } catch (error) {
      console.error(error)
    }

    return
  },
}

export default NominationsApi
